export enum RefProvider {
  Standalone = 'STANDALONE',
  StoreBuilder = 'STORE_BUILDER',
  ZenDrop = 'ZENDROP',
  AutoDS = 'AUTODS',
}

export enum WelcomeVariant {
  Morrison = 'morrison',
}

export enum Category {
  WomensFashion = 'WOMENS_FASHION',
  MensFashion = 'MENS_FASHION',
  JewelryAccessories = 'JEWELRY_ACCESSORIES',
  KidsBabies = 'KIDS_BABIES',
  BeautyHealth = 'BEAUTY_HEALTH',
  HomeGarden = 'HOME_GARDEN',
  SportsEntertainment = 'SPORTS_ENTERTAINMENT',
  BagsLuggage = 'BAGS_LUGGAGE',
  ConsumerElectronics = 'CONSUMER_ELECTRONICS',
  Pets = 'PETS',
}
